import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../../hooks/useScrollAnimation";
import FaqAccordion from "../../../components/Faq/FaqAccordion";
import useFaqs from "../../../components/Faq/useFaqs";

const HOMEPAGE_LIMIT = 5;

const ArdrendFAQ = () => {
  const { t } = useTranslation();
  const { faqs, loading } = useFaqs({ limit: HOMEPAGE_LIMIT });
  const ref = useScrollAnimation();

  if (!loading && faqs.length === 0) return null;

  return (
    <section ref={ref} className="py-24 bg-white relative">
      <div className="max-w-[1000px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16 lg:mb-20 gap-8 animate-on-scroll animate-fade-up">
          <div className="w-full lg:w-1/2">
            <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-gray-400 mb-6 flex items-center gap-3">
              <span className="block w-8 h-[2px] bg-primary"></span>
              {t("home.faq.kicker")}
            </div>
            <h2 className="text-[#0b0f19] text-3xl md:text-5xl font-bold">
              {t("home.faq.title")}<span className="text-primary">.</span>
            </h2>
          </div>
          <div className="w-full lg:w-1/2 flex lg:justify-end">
            <p className="text-gray-500 text-lg max-w-[400px] leading-relaxed border-l border-primary/30 pl-6">
              {t("home.faq.subtitle")}
            </p>
          </div>
        </div>

        <div className="animate-on-scroll animate-fade-up delay-200">
          {loading ? (
            <div className="flex flex-col gap-5">
              {[1, 2, 3].map((n) => (
                <div key={n} className="h-[88px] rounded-[10px] border border-gray-100 bg-gray-50 animate-pulse" />
              ))}
            </div>
          ) : (
            <FaqAccordion faqs={faqs} />
          )}

          <div className="mt-12 flex justify-center">
            <Link
              to="/faq"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full border border-gray-300 text-[#0b0f19] font-bold hover:border-primary hover:text-primary transition-colors duration-300"
            >
              {t("home.faq.viewAll")}
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArdrendFAQ;
